module.exports = __webpack_public_path__ + "img/87.7127202f.png";